(function () {
  const MAX_SCALE = 4;
  const DOUBLE_TAP_MS = 280;

  function clamp(value, min, max) {
    return Math.min(max, Math.max(min, value));
  }

  function largestSrc(img) {
    const srcset = img.getAttribute('srcset');
    if (!srcset) return img.currentSrc || img.src;
    let bestUrl = img.currentSrc || img.src;
    let bestWidth = 0;
    srcset.split(',').forEach(function (part) {
      const bits = part.trim().split(/\s+/);
      const url = bits[0];
      const width = bits[1] && bits[1].slice(-1) === 'w' ? parseInt(bits[1], 10) : 0;
      if (url && width >= bestWidth) {
        bestWidth = width;
        bestUrl = url;
      }
    });
    return bestUrl;
  }

  function galleryFrom(button) {
    const opener = button.closest('modal-opener');
    const modal = opener && document.querySelector(opener.getAttribute('data-modal'));
    const mediaId = button.getAttribute('data-media-id');
    const images = modal ? Array.from(modal.querySelectorAll('img[data-media-id]')) : [];
    const list = [];
    const seen = {};
    images.forEach(function (img) {
      const id = img.getAttribute('data-media-id');
      const src = largestSrc(img);
      if (!src || seen[id]) return;
      seen[id] = true;
      list.push({ src: src, alt: img.getAttribute('alt') || '', id: id });
    });
    if (!list.length) {
      const fallback = opener && opener.querySelector('img');
      if (fallback) {
        list.push({
          src: fallback.currentSrc || fallback.src,
          alt: fallback.getAttribute('alt') || '',
          id: mediaId,
        });
      }
    }
    let index = list.findIndex(function (item) {
      return item.id === mediaId;
    });
    if (index < 0) index = 0;
    return { list: list, index: index };
  }

  function Lightbox() {
    this.scale = 1;
    this.x = 0;
    this.y = 0;
    this.list = [];
    this.index = 0;
    this.openState = false;
    this.pointers = new Map();
    this.drag = null;
    this.pinch = null;
    this.lastTap = 0;
    this.lastFocus = null;
    this.build();
    this.bind();
  }

  Lightbox.prototype.build = function () {
    const root = document.createElement('div');
    root.className = 'hs-lightbox';
    root.setAttribute('role', 'dialog');
    root.setAttribute('aria-modal', 'true');
    root.setAttribute('aria-label', 'Product image');
    root.hidden = true;
    root.innerHTML =
      '<div class="hs-lightbox__stage">' +
      '<img class="hs-lightbox__img" alt="" draggable="false">' +
      '</div>' +
      '<button type="button" class="hs-lightbox__close" aria-label="Close">' +
      '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>' +
      '</button>' +
      '<button type="button" class="hs-lightbox__nav hs-lightbox__nav--prev" aria-label="Previous image">' +
      '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M14.5 6l-6 6 6 6"/></svg>' +
      '</button>' +
      '<button type="button" class="hs-lightbox__nav hs-lightbox__nav--next" aria-label="Next image">' +
      '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9.5 6l6 6-6 6"/></svg>' +
      '</button>' +
      '<p class="hs-lightbox__count" aria-live="polite"></p>';
    document.body.appendChild(root);
    this.root = root;
    this.stage = root.querySelector('.hs-lightbox__stage');
    this.img = root.querySelector('.hs-lightbox__img');
    this.closeBtn = root.querySelector('.hs-lightbox__close');
    this.prevBtn = root.querySelector('.hs-lightbox__nav--prev');
    this.nextBtn = root.querySelector('.hs-lightbox__nav--next');
    this.countEl = root.querySelector('.hs-lightbox__count');
  };

  Lightbox.prototype.bind = function () {
    const self = this;
    document.addEventListener(
      'click',
      function (event) {
        const button = event.target.closest('[data-hs-lightbox]');
        if (!button) return;
        event.preventDefault();
        event.stopPropagation();
        const gallery = galleryFrom(button);
        if (!gallery.list.length) return;
        self.open(gallery.list, gallery.index);
      },
      true
    );

    this.closeBtn.addEventListener('click', function () {
      self.close();
    });
    this.prevBtn.addEventListener('click', function () {
      self.step(-1);
    });
    this.nextBtn.addEventListener('click', function () {
      self.step(1);
    });

    this.stage.addEventListener('pointerdown', function (event) {
      if (!self.openState) return;
      self.stage.setPointerCapture(event.pointerId);
      self.pointers.set(event.pointerId, { x: event.clientX, y: event.clientY });
      if (self.pointers.size === 1) {
        self.drag = {
          id: event.pointerId,
          x: event.clientX,
          y: event.clientY,
          ox: self.x,
          oy: self.y,
          moved: false,
          pointerType: event.pointerType,
        };
        self.pinch = null;
      } else if (self.pointers.size === 2) {
        self.pinch = self.pinchStart();
        self.drag = null;
      }
    });

    this.stage.addEventListener('pointermove', function (event) {
      if (!self.pointers.has(event.pointerId)) return;
      self.pointers.set(event.pointerId, { x: event.clientX, y: event.clientY });
      if (self.pointers.size >= 2 && self.pinch) {
        self.pinchMove();
        return;
      }
      if (!self.drag || self.drag.id !== event.pointerId) return;
      const dx = event.clientX - self.drag.x;
      const dy = event.clientY - self.drag.y;
      if (Math.hypot(dx, dy) > 6) self.drag.moved = true;
      if (self.scale > 1) {
        self.x = self.drag.ox + dx;
        self.y = self.drag.oy + dy;
        self.clampPan();
        self.apply(false);
      } else if (self.list.length > 1) {
        self.x = dx;
        self.y = 0;
        self.apply(false);
      }
    });

    this.stage.addEventListener('pointerup', function (event) {
      self.finishPointer(event);
    });
    this.stage.addEventListener('pointercancel', function (event) {
      self.finishPointer(event);
    });

    this.img.addEventListener('dblclick', function (event) {
      event.preventDefault();
      if (self.scale > 1) self.resetZoom(true);
      else self.zoomAt(event.clientX, event.clientY, 2.5, true);
    });

    this.root.addEventListener(
      'wheel',
      function (event) {
        if (!self.openState) return;
        event.preventDefault();
        const next = self.scale * Math.exp(-event.deltaY * 0.0016);
        self.zoomAt(event.clientX, event.clientY, next, false);
      },
      { passive: false }
    );

    document.addEventListener('keydown', function (event) {
      if (!self.openState) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        self.close();
      } else if (event.key === 'ArrowRight') {
        event.preventDefault();
        self.step(1);
      } else if (event.key === 'ArrowLeft') {
        event.preventDefault();
        self.step(-1);
      }
    });
  };

  Lightbox.prototype.pinchStart = function () {
    const pts = Array.from(this.pointers.values());
    const midX = (pts[0].x + pts[1].x) / 2;
    const midY = (pts[0].y + pts[1].y) / 2;
    const local = this.localPoint(midX, midY);
    return {
      dist: Math.hypot(pts[0].x - pts[1].x, pts[0].y - pts[1].y) || 1,
      scale: this.scale,
      px: local.x,
      py: local.y,
    };
  };

  Lightbox.prototype.pinchMove = function () {
    const pts = Array.from(this.pointers.values());
    const dist = Math.hypot(pts[0].x - pts[1].x, pts[0].y - pts[1].y) || 1;
    const midX = (pts[0].x + pts[1].x) / 2;
    const midY = (pts[0].y + pts[1].y) / 2;
    this.scale = clamp(this.pinch.scale * (dist / this.pinch.dist), 1, MAX_SCALE);
    this.placePoint(midX, midY, this.pinch.px, this.pinch.py);
    if (this.scale === 1) {
      this.x = 0;
      this.y = 0;
    } else {
      this.clampPan();
    }
    this.apply(false);
  };

  Lightbox.prototype.finishPointer = function (event) {
    const drag = this.drag;
    this.pointers.delete(event.pointerId);
    if (this.pointers.size < 2) this.pinch = null;
    if (this.pointers.size === 1) {
      let remainingId = null;
      let remainingPoint = null;
      this.pointers.forEach(function (point, id) {
        remainingId = id;
        remainingPoint = point;
      });
      this.drag = {
        id: remainingId,
        x: remainingPoint.x,
        y: remainingPoint.y,
        ox: this.x,
        oy: this.y,
        moved: true,
        pointerType: 'touch',
      };
      return;
    }
    if (this.pointers.size > 0) return;
    this.drag = null;
    if (!drag) return;
    const dx = event.clientX - drag.x;
    const dy = event.clientY - drag.y;
    if (this.scale === 1 && this.list.length > 1 && Math.abs(dx) > 48 && Math.abs(dx) > Math.abs(dy) * 1.15) {
      this.step(dx < 0 ? 1 : -1);
      return;
    }
    if (this.scale === 1) {
      this.x = 0;
      this.y = 0;
      this.apply(true);
      if (!drag.moved && drag.pointerType === 'touch' && event.target === this.img) {
        this.onTap(event);
      } else if (!drag.moved && event.target === this.stage) {
        this.close();
      }
      return;
    }
    this.clampPan();
    this.apply(true);
  };

  Lightbox.prototype.onTap = function (event) {
    const now = Date.now();
    if (now - this.lastTap < DOUBLE_TAP_MS) {
      if (this.scale > 1) this.resetZoom(true);
      else this.zoomAt(event.clientX, event.clientY, 2.5, true);
      this.lastTap = 0;
      return;
    }
    this.lastTap = now;
  };

  Lightbox.prototype.localPoint = function (clientX, clientY) {
    const stageRect = this.stage.getBoundingClientRect();
    return {
      x: (clientX - (stageRect.left + stageRect.width / 2 + this.x)) / this.scale,
      y: (clientY - (stageRect.top + stageRect.height / 2 + this.y)) / this.scale,
    };
  };

  Lightbox.prototype.placePoint = function (clientX, clientY, px, py) {
    const stageRect = this.stage.getBoundingClientRect();
    this.x = clientX - (stageRect.left + stageRect.width / 2) - px * this.scale;
    this.y = clientY - (stageRect.top + stageRect.height / 2) - py * this.scale;
  };

  Lightbox.prototype.zoomAt = function (clientX, clientY, nextScale, animate) {
    const local = this.localPoint(clientX, clientY);
    this.scale = clamp(nextScale, 1, MAX_SCALE);
    if (this.scale === 1) {
      this.x = 0;
      this.y = 0;
    } else {
      this.placePoint(clientX, clientY, local.x, local.y);
      this.clampPan();
    }
    this.apply(animate);
  };

  Lightbox.prototype.clampPan = function () {
    const stageRect = this.stage.getBoundingClientRect();
    const maxX = Math.max(0, (this.img.clientWidth * this.scale - stageRect.width) / 2);
    const maxY = Math.max(0, (this.img.clientHeight * this.scale - stageRect.height) / 2);
    this.x = clamp(this.x, -maxX, maxX);
    this.y = clamp(this.y, -maxY, maxY);
  };

  Lightbox.prototype.apply = function (animate) {
    this.img.classList.toggle('is-settling', !!animate);
    this.root.classList.toggle('is-zoomed', this.scale > 1);
    this.img.style.transform = 'translate(' + this.x + 'px, ' + this.y + 'px) scale(' + this.scale + ')';
  };

  Lightbox.prototype.resetZoom = function (animate) {
    this.scale = 1;
    this.x = 0;
    this.y = 0;
    this.apply(animate);
  };

  Lightbox.prototype.open = function (list, index) {
    this.list = list;
    this.index = index;
    this.openState = true;
    this.lastFocus = document.activeElement;
    this.root.hidden = false;
    this.root.classList.add('is-open');
    document.documentElement.classList.add('hs-lightbox-open');
    this.show(false);
    this.closeBtn.focus();
  };

  Lightbox.prototype.close = function () {
    if (!this.openState) return;
    this.openState = false;
    this.root.classList.remove('is-open');
    this.root.hidden = true;
    document.documentElement.classList.remove('hs-lightbox-open');
    this.resetZoom(false);
    if (this.lastFocus && this.lastFocus.focus) this.lastFocus.focus();
  };

  Lightbox.prototype.step = function (direction) {
    if (this.list.length < 2) return;
    this.index = (this.index + direction + this.list.length) % this.list.length;
    this.show(true);
  };

  Lightbox.prototype.show = function (animate) {
    const item = this.list[this.index];
    const several = this.list.length > 1;
    this.prevBtn.hidden = !several;
    this.nextBtn.hidden = !several;
    this.countEl.hidden = !several;
    this.countEl.textContent = this.index + 1 + ' / ' + this.list.length;
    this.scale = 1;
    this.x = 0;
    this.y = 0;
    this.img.classList.remove('is-ready');
    this.apply(animate);
    const self = this;
    const src = item.src;
    function ready() {
      if (self.img.getAttribute('src') !== src) return;
      self.img.classList.add('is-ready');
    }
    this.img.onload = ready;
    this.img.alt = item.alt;
    this.img.src = src;
    if (this.img.complete && this.img.naturalWidth) ready();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      new Lightbox();
    });
  } else {
    new Lightbox();
  }
})();
